// extracted by mini-css-extract-plugin
module.exports = {"whiteboard":"Whiteboard_whiteboard__KVI4A"};